export default {
  parcelas: [
    {
      id: 1,
      value: '1 parcela anual'
    },
    {
      id: 2,
      value: '2 parcelas anuais'
    },
    {
      id: 3,
      value: '3 parcelas anuais'
    },
    {
      id: 4,
      value: '4 parcelas anuais'
    },
    {
      id: 5,
      value: '5 parcelas anuais'
    },
    {
      id: 6,
      value: '6 parcelas anuais'
    },
    {
      id: 7,
      value: '7 parcelas anuais'
    },
    {
      id: 8,
      value: '8 parcelas anuais'
    },
    {
      id: 9,
      value: '9 parcelas anuais'
    },
    {
      id: 10,
      value: '10 parcelas anuais'
    },
    {
      id: 11,
      value: '11 parcelas anuais'
    },
    {
      id: 12,
      value: '12 parcelas anuais'
    },
    {
      id: 13,
      value: '13 parcelas anuais'
    },
    {
      id: 14,
      value: '14 parcelas anuais'
    },
    {
      id: 15,
      value: '15 parcelas anuais'
    },
    {
      id: 16,
      value: '16 parcelas anuais'
    },
    {
      id: 17,
      value: '17 parcelas anuais'
    },
    {
      id: 18,
      value: '18 parcelas anuais'
    },
    {
      id: 19,
      value: '19 parcelas anuais'
    },
    {
      id: 20,
      value: '20 parcelas anuais'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/screens/analise/vtn/constants/parcelas.js